const isDev = process.env.VUE_APP_ENV === 'dev';
export default isDev;
